import { useEffect, useState } from "react";
import { TESTIMONIALS } from "../data/siteData";
import { Star, Quote, ChevronLeft, ChevronRight } from "lucide-react";

export const Testimonials = () => {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % TESTIMONIALS.length), 6000);
    return () => clearInterval(t);
  }, []);

  const prev = () => setIdx((i) => (i - 1 + TESTIMONIALS.length) % TESTIMONIALS.length);
  const next = () => setIdx((i) => (i + 1) % TESTIMONIALS.length);

  const t = TESTIMONIALS[idx];

  return (
    <section id="testimonios" className="section-padding bg-beige-50 relative overflow-hidden" data-testid="testimonials-section">
      <div className="absolute top-10 left-10 opacity-10">
        <Quote size={140} className="text-gold" />
      </div>
      <div className="absolute bottom-10 right-10 opacity-10 rotate-180">
        <Quote size={140} className="text-gold" />
      </div>

      <div className="container-aura relative">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <div className="text-xs tracking-luxe uppercase text-gold mb-4">Testimonios</div>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-ink leading-tight mb-5">
            Lo que dicen <span className="italic text-gold">nuestras clientas</span>
          </h2>
          <div className="gold-divider mx-auto"></div>
        </div>

        <div className="max-w-3xl mx-auto text-center">
          <div className="flex justify-center gap-1 mb-6" data-testid={`testimonial-stars-${t.id}`}>
            {[...Array(t.rating)].map((_, i) => (
              <Star key={i} size={22} className="text-gold fill-gold" />
            ))}
          </div>

          <p className="font-serif text-2xl md:text-3xl lg:text-4xl text-ink italic leading-snug mb-8 min-h-[180px] flex items-center justify-center px-4" data-testid={`testimonial-text-${t.id}`}>
            &ldquo;{t.text}&rdquo;
          </p>

          <div className="mb-2">
            <div className="font-serif text-xl text-ink" data-testid={`testimonial-name-${t.id}`}>{t.name}</div>
            <div className="text-xs tracking-luxe uppercase text-ink-soft mt-1">{t.treatment}</div>
          </div>

          {/* Controls */}
          <div className="flex items-center justify-center gap-4 mt-10">
            <button
              onClick={prev}
              data-testid="testimonials-prev"
              className="w-11 h-11 rounded-full border border-beige-300 hover:border-gold hover:bg-gold hover:text-white transition-all flex items-center justify-center text-ink"
              aria-label="Anterior"
            >
              <ChevronLeft size={18} />
            </button>
            <div className="flex gap-2" data-testid="testimonials-dots">
              {TESTIMONIALS.map((_, i) => (
                <button
                  key={i}
                  onClick={() => setIdx(i)}
                  data-testid={`testimonial-dot-${i}`}
                  className={`h-1.5 rounded-full transition-all ${i === idx ? "w-8 bg-gold" : "w-1.5 bg-beige-300"}`}
                  aria-label={`Testimonio ${i + 1}`}
                />
              ))}
            </div>
            <button
              onClick={next}
              data-testid="testimonials-next"
              className="w-11 h-11 rounded-full border border-beige-300 hover:border-gold hover:bg-gold hover:text-white transition-all flex items-center justify-center text-ink"
              aria-label="Siguiente"
            >
              <ChevronRight size={18} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};
